import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  isLaunchMode,
  LAUNCH_MODE_GUEST_PATHS,
  normalizeLaunchPathname,
} from '../../utils/launchMode';

/**
 * Launch mode routing:
 * - Guests on disallowed paths → `/launch`
 * - Signed-in users on `/launch` → `/` (full app home)
 */
export default function LaunchModeGate({ children }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();

  const normalized = normalizeLaunchPathname(pathname);

  if (loading) {
    return children;
  }

  if (isLaunchMode() && user && normalized === '/launch') {
    return <Navigate to="/" replace />;
  }

  if (!isLaunchMode() || user) {
    return children;
  }

  if (LAUNCH_MODE_GUEST_PATHS.has(normalized)) {
    return children;
  }

  return <Navigate to="/launch" replace />;
}
